export default "__VITE_ASSET__07fa43c0__"